import { render, staticRenderFns } from "./SessionMiniature.vue?vue&type=template&id=db54edee"
import script from "./SessionMiniature.vue?vue&type=script&lang=js"
export * from "./SessionMiniature.vue?vue&type=script&lang=js"
import style0 from "./SessionMiniature.vue?vue&type=style&index=0&id=db54edee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports